    function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
    function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
   function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
   function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }
   function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
  
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.onFormSubmit = this.debouncedOnSubmit.bind(this);

    const form = this.querySelector('form');
    form.addEventListener('input', this.onFormSubmit);
    form.addEventListener('change', this.onFormSubmit);

    this.addEventListener('collection:abort-loading', () => {
      FacetFiltersForm.abortPendingFetch();
      FacetFiltersForm.clearLoadingState();
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static clearLoadingState() {
    const gridContainer = document.getElementById('ProductGridContainer');
    const collection = gridContainer && gridContainer.querySelector('.collection');
    if (collection) {
      collection.classList.remove('loading');
    }

    const countContainer = document.getElementById('ProductCount');
    if (countContainer) {
      countContainer.classList.remove('loading');
    }

    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainerDesktop) {
      countContainerDesktop.classList.remove('loading');
    }
  }

  static abortPendingFetch() {
    if (FacetFiltersForm.abortController) {
      FacetFiltersForm.abortController.abort();
      FacetFiltersForm.abortController = null;
    }
  }

  static finishRender(renderId) {
    if (renderId === FacetFiltersForm.currentRenderId) {
      FacetFiltersForm.clearLoadingState();
    }
  }

  static addLoadingState() {
    const gridContainer = document.getElementById('ProductGridContainer');
    const collection = gridContainer && gridContainer.querySelector('.collection');
    if (collection) {
      collection.classList.add('loading');
    }

    const countContainer = document.getElementById('ProductCount');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
  }

  static initProductReviews() {
    if (typeof window.SPR === 'undefined') return;

    window.SPR.registerCallbacks();
    window.SPR.initRatingHandler();
    window.SPR.initDomEls();
    window.SPR.loadProducts();
    window.SPR.loadBadges();
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm.currentRenderId = (FacetFiltersForm.currentRenderId || 0) + 1;
    const renderId = FacetFiltersForm.currentRenderId;
    const sections = FacetFiltersForm.getSections();

    FacetFiltersForm.abortPendingFetch();
    FacetFiltersForm.addLoadingState();

    sections.forEach((section) => {
      const url = searchParams
        ? `${window.location.pathname}?section_id=${section.section}&${searchParams}`
        : `${window.location.pathname}?section_id=${section.section}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, renderId) :
        FacetFiltersForm.renderSectionFromFetch(url, event, renderId);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, renderId) {
    FacetFiltersForm.abortController = new AbortController();

    fetch(url, { signal: FacetFiltersForm.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        if (renderId !== FacetFiltersForm.currentRenderId) return;

        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderSectionFromHtml(html, event);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('Collection filter update failed.', error);
      })
      .finally(() => {
        FacetFiltersForm.abortController = null;
        FacetFiltersForm.finishRender(renderId);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, renderId) {
    if (renderId !== FacetFiltersForm.currentRenderId) return;

    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSectionFromHtml(html, event);
    FacetFiltersForm.finishRender(renderId);
  }

  static renderSectionFromHtml(html, event) {
    try {
      FacetFiltersForm.renderProductCount(html);
    } catch (error) {
      console.error('Collection product count update failed.', error);
    }

    try {
      FacetFiltersForm.renderFilters(html, event);
    } catch (error) {
      console.error('Collection filter sidebar update failed.', error);
    }

    try {
      FacetFiltersForm.renderProductGridContainer(html);
    } catch (error) {
      console.error('Collection product grid update failed.', error);
    }

    FacetFiltersForm.clearLoadingState();
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceGrid = parsedHTML.getElementById('ProductGridContainer');
    const targetGrid = document.getElementById('ProductGridContainer');

    if (!sourceGrid || !targetGrid) return;

    targetGrid.innerHTML = sourceGrid.innerHTML;
    const collection = targetGrid.querySelector('.collection');
    if (collection) {
      collection.classList.remove('loading');
    }
    FacetFiltersForm.initProductReviews();
    $(document).ready(function() {
      $('.ajax-spin-cart').on('click', function() {
        if (typeof window.technixiaHideAllTooltips === 'function') {
          window.technixiaHideAllTooltips();
        }
        $(this).blur();
        $(this).addClass('loading add-item');
        setTimeout(function () {
          $('.ajax-spin-cart').removeClass('loading');
        },1000);
        setTimeout(function () {
          $('.ajax-spin-cart').removeClass("add-item");
        },2000);
      });
      $(".ajax-spin-cart").click(function(){
        window.setTimeout(function() {
          if (typeof window.technixiaRefreshMiniCart === 'function') {
            window.technixiaRefreshMiniCart(function() {
              if (typeof window.technixiaOpenMiniCart === 'function') {
                window.technixiaOpenMiniCart();
              }
            });
          } else if (typeof window.technixiaOpenMiniCart === 'function') {
            window.technixiaOpenMiniCart();
          }
        }, 1000);
      });
      
      // wishlist js
      var $wishlistButton = $('.wishlist-btn');
      var $wishlistTile = $('.wishlist-tile-container');
      var $wishlitcounter = $('.wishlist-counter');
      var numProductTiles = $wishlistTile.length;

      var getStoredWishlist = function () {
        try {
          var raw = localStorage.getItem('user_wishlist');
          if (!raw) {
            return [];
          }
          var parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      };

      var syncWishlistCount = function (count) {
        var safeCount = Math.max(parseInt(count, 10) || 0, 0);
        localStorage.setItem('user_wishlist_count', String(safeCount));
        $wishlitcounter.html(String(safeCount));
      };

      var wishlist = getStoredWishlist();
      syncWishlistCount(wishlist.length);

      /*
      * Update button to show current state (gold for active)
      */   
      var animateWishlist = function (self) {
        $(self).toggleClass('is-active');
      };

      /*
      * Add/Remove selected item to the user's wishlist array in localStorage
      * Wishlist button class 'is-active' determines whether or not to add or remove
      * If 'is-active', remove the item, otherwise add it
      */   
      var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('is-active');

        if (isRemove) {
          var removeIndex = wishlist.indexOf(productHandle);
          if (removeIndex > -1) {
            wishlist.splice(removeIndex, 1);
          }
        } else if (wishlist.indexOf(productHandle) === -1) {
          wishlist.push(productHandle);
        }

        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        syncWishlistCount(wishlist.length);

        var icon_length = $(self).find("span").length;
        if (icon_length != 0 && attr != 'product') {
          $wishlistButton.html('<span class="add-wishlist"><i class="ri-heart-line"></i></span><span class="loading-wishlist load-anim"><i class="ri-loader-4-line"></i></span><span class="remove-wishlist"><i class="ri-heart-fill"></i></span>');
        }
      };

      /*
      * Loop through product titles and remove any that aren't a part of the wishlist
      * Decrement numProductTiles on removal
      */   
      var activateItemsInWishlist = function () {
        $wishlistButton.each(function () {
          var productHandle = $(this).attr('data-product-handle');
          if (wishlist.indexOf(productHandle) > -1) {
            $(this).addClass('is-active');
            var icon_length = $(this).find("span").length;
            if($(this).hasClass('is-active')){
              if(icon_length != 0 && attr != 'product'){
                $(this).html('<span class="add-wishlist"><i class="ri-heart-line"></i></span><span class="loading-wishlist load-anim"><i class="ri-loader-4-line"></i></span><span class="remove-wishlist"><i class="ri-heart-fill"></i></span>');
              }
            }else{
              if(icon_length != 0 && attr != 'product'){
                $(this).html('<span class="add-wishlist"><i class="ri-heart-line"></i></span><span class="loading-wishlist load-anim"><i class="ri-loader-4-line"></i></span><span class="remove-wishlist"><i class="ri-heart-fill"></i></span>');
              }
            }
          }
        });
      };
      var displayOnlyWishlistItems = function () {
        $wishlistTile.each(function () {
          var productHandle = $(this).attr('data-product-handle');
          if (wishlist.indexOf(productHandle) === -1) {
            $(this).remove();
            numProductTiles--;
          }
        });
      };

      /*
      * Check if on the wishlist page and hide any items that aren't a part of the wishlist
      * If no wishlist items exist, show the empty wishlist notice
      */   
      var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') > -1) {
          displayOnlyWishlistItems();
          syncWishlistCount(numProductTiles);
          $('.wishlist-loader').fadeOut(2000, function () {
            $('.wishlist-grid').addClass('is_visible');
            $('.wishlist-hero').addClass('is_visible');
            if (numProductTiles === 0) {
              $('.wishlist-grid-empty-list').addClass('is_visible').show();
              $('.wishlist-grid').hide();
            } else {
              $('.wishlist-grid-empty-list').removeClass('is_visible').hide();
              $('.wishlist-grid').show();
            }
          });
        }
      };

      var bindUIActions = function () {
        $wishlistButton.click(function (e) {
          e.preventDefault();
          updateWishlist(this);
          animateWishlist(this);
        });
      };

      Wishlist.init = function () {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
      };

      $("#remove-done").click(function (e) {
        e.preventDefault();
        wishlist = [];
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        syncWishlistCount(0);
        location.reload();
      });

      // wishlist ajax-spin-cart js
      $(".action-wishlist").on('click', function() {
        $(this).addClass("loading-wishlist adding-wishlist");
        setTimeout(function () {
          $(".action-wishlist").removeClass("loading-wishlist load-anim");
        },1000);
        setTimeout(function () {
          $(".adding-wishlist").removeClass("adding-wishlist");
        },2000);
      });

      var productGrid = document.getElementById('ProductGridContainer');
      if (productGrid) {
        productGrid.querySelectorAll('[data-bs-toggle="tooltip"]:not(.wishlist-btn)').forEach(function (el) {
          var existing = bootstrap.Tooltip.getInstance(el);
          if (existing) {
            existing.dispose();
          }
          new bootstrap.Tooltip(el);
        });
        if (window.initWishlistTooltips) {
          window.initWishlistTooltips(productGrid);
        }
      }
    });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHTML.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      if (sourceCount) {
        container.innerHTML = sourceCount.innerHTML;
      }
      container.classList.remove('loading');
    }

    if (containerDesktop) {
      if (sourceCount) {
        containerDesktop.innerHTML = sourceCount.innerHTML;
      }
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) {
        target.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
      const targetFilter = event.target.closest('.js-filter');
      if (targetFilter) {
        FacetFiltersForm.renderCounts(countsToRender, targetFilter);
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!activeFacetsElement || !targetElement) return;
      targetElement.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!sourceElement || !targetElement) return;
      targetElement.innerHTML = sourceElement.innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const linkUrl = new URL(link.href, window.location.origin);

    if (linkUrl.pathname !== window.location.pathname) {
      window.location.href = link.href;
      return;
    }

    const searchParams = linkUrl.search.length > 1 ? linkUrl.search.slice(1) : '';

    if (!searchParams && link.classList.contains('clear-all')) {
      window.location.href = link.href;
      return;
    }

    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(searchParams);
  }
}


FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.abortController = null;
FacetFiltersForm.currentRenderId = 0;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

var PriceRange = /*#__PURE__*/function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);

    var _super = _createSuper(PriceRange);

    function PriceRange() {
      _classCallCheck(this, PriceRange);

      return _super.apply(this, arguments);
    }

    _createClass(PriceRange, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;

        this.rangeLowerBound = this.querySelector('.price-range-group input:first-child');
        this.rangeHigherBound = this.querySelector('.price-range-group input:last-child');
        this.textInputLowerBound = this.querySelector('.price-range-input:first-child input');
        this.textInputHigherBound = this.querySelector('.price-range-input:last-child input'); // Select whole text on focus for text field to improve user experience

        this.textInputLowerBound.addEventListener('focus', function () {
          return _this.textInputLowerBound.select();
        });
        this.textInputHigherBound.addEventListener('focus', function () {
          return _this.textInputHigherBound.select();
        }); // Keep in sync the range with the text input fields

        this.textInputLowerBound.addEventListener('change', function (event) {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;

          _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
        });
        this.textInputHigherBound.addEventListener('change', function (event) {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;

          _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
        });
        this.rangeLowerBound.addEventListener('change', function (event) {
          _this.textInputLowerBound.value = event.target.value;

          _this.textInputLowerBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
        this.rangeHigherBound.addEventListener('change', function (event) {
          _this.textInputHigherBound.value = event.target.value;

          _this.textInputHigherBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }); // We also have to bound the two range sliders

        this.rangeLowerBound.addEventListener('input', function (event) {
          _this.dispatchEvent(new CustomEvent('collection:abort-loading', {
            bubbles: true
          }));

          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener('input', function (event) {
          _this.dispatchEvent(new CustomEvent('collection:abort-loading', {
            bubbles: true
          }));

          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputHigherBound.value = event.target.value;
        });
      }
    }]);

    return PriceRange;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  connectedCallback() {
    if (this._facetRemoveBound) return;
    this._facetRemoveBound = true;

    const link = this.querySelector('a');
    if (!link) return;

    link.addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      if (form && typeof form.onActiveFilterClick === 'function') {
        form.onActiveFilterClick(event);
        return;
      }
      window.location.href = link.href;
    });
  }
}

customElements.define('facet-remove', FacetRemove);
